import { Box, Breadcrumbs, Tab, Tabs, Typography } from "@mui/material";
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import AllUsers from "./AllUsers";
import RazorPayUsers from "./RazorPayUsers";
import PurchasedUsers from "./PurchasedUsers";
import NotificationsList from "./NotificationsList";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: { xs: 1, md: 3 } }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function Users() {
  const [value, setValue] = React.useState(
    Number(localStorage.getItem("userTabIndex")) || 0
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
    localStorage.setItem("userTabIndex", newValue);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: { xs: "flex-start", md: "space-between" },
          alignItems: { xs: "stretch", md: "center" },
          gap: { xs: 1, md: 0 },
          mb: 2,
          mt: 1,
          marginLeft: "10px",
        }}
      >
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
          <Link underline="hover" color="inherit" to="/booklist">
            Books List
          </Link>
          <Typography sx={{ color: "text.primary", fontWeight: 600 }}>
            Users Management
          </Typography>
        </Breadcrumbs>
      </Box>

      <Box sx={{ width: "100%", overflowX: "auto" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="basic tabs example"
            TabIndicatorProps={{
              style: {
                backgroundColor: "#17479e",
                height: 2,
              },
            }}
            sx={{
              "& .MuiTab-root": {
                color: "#555",
                fontWeight: 600,
                textTransform: "none",
                minWidth: "120px", // mobile friendly
              },
              "& .Mui-selected": {
                color: "#17479e !important",
              },
            }}
          >
            <Tab label="All Users" {...a11yProps(0)} />
            <Tab label="Users Razorpay Order" {...a11yProps(1)} />
            <Tab label="Users Purchases" {...a11yProps(2)} />
            <Tab label="Notifications List" {...a11yProps(3)} />
          </Tabs>
        </Box>

        <CustomTabPanel
          value={value}
          index={0}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <AllUsers />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={1}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <RazorPayUsers />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={2}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <PurchasedUsers />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={3}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <NotificationsList />
        </CustomTabPanel>
      </Box>
    </>
  );
}

export default Users;
